<div class="PageTitle">
  <h3 style="text-align:left; padding-left: 2%; font-family: Roboto,Arial,sans-serif,Nucleo; color: #004f86;">Single
    User Setup ICC</h3>
</div>
<hr>

<div class="row">

  <!-- spinner when loading -->
  <div *ngIf="useSpinner" style="padding-left: 40%; padding-top: 15%;">
    <mat-spinner></mat-spinner>
  </div>

  <div *ngIf="!useSpinner" class="col-md-12">
    <div class="row ">
      <div class="col-md-12">
      </div>

      <div class="col-md-6">
        <mat-card>

          <mat-card-header style="background-color: #004f86; padding: 5px; color: white;">
            <mat-card-title>{{ leftPanelTitle }}</mat-card-title>
          </mat-card-header>
          <br>

          <mat-card-content>

            <!-- Prompt user for valid user ID for Infact before allowing the use of this screen -->
            <div [class.mat-elevation-z12]="true" style="padding: 12px" *ngIf="!validInfactUser">
              <form>
                <!-- <div class="row">
                  <div class="col">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Infact User ID</mat-label>
                      <input [formControl]="infactUserIdInputControl" matInput placeholder="Infact User ID" value="">
                    </mat-form-field>
                  </div>
                </div> -->

                <!-- <div class="row">
                  <div class="button-row col">
                    <button class="mr-1" mat-flat-button color="primary" (click)="verifyInfactUserButton()"
                      [disabled]="verifyInfactUserButtonDisable">Submit</button>
                  </div>
                </div> -->
              </form>
            </div>

            <!-- employee ID entry and row below will be search or inactivate buttons -->
            <div [class.mat-elevation-z12]="true" style="padding: 12px" *ngIf="validInfactUser">
              <form>
                <div class="row">
                  <div class="col">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Employee ID</mat-label>
                      <input [formControl]="employeeIdControl" matInput placeholder="Employee ID" value=""
                        maxlength="10">
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="button-row col">
                    <button class="mr-1" mat-flat-button color="primary" (click)="searchButton()">Search</button>
                    <!-- <button mat-flat-button color="primary" (click)="newUserButton()">New User</button> -->
                  </div>
                </div>
              </form>
            </div>


          </mat-card-content>
        </mat-card>

        <br>

        <!-- <row *ngIf="showSubmissionStatus"> -->
        <mat-card *ngIf="showSubmissionStatus">
          <mat-card-header style="background-color: #004f86; padding: 5px; color: white;">
            <mat-card-title>Submission Status</mat-card-title>
          </mat-card-header>
          <br>
          <mat-card-content>

            <!-- inactivate user status -->
            <div *ngIf="showInactivateUserStatuses">
              <div class="row" *ngIf="showInactivateSuccessStatusEDH !== ''">
                <div class="col">
                  <h4>EDH Inactivate User Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showInactivateSuccessStatusEDH === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showInactivateSuccessStatusEDH === 'false'">Unsuccessful</h4>
                </div>
              </div>
              <div class="row" *ngIf="showInactivateSuccessStatusHAR !== ''">
                <div class="col">
                  <h4>HAR Inactivate User Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showInactivateSuccessStatusHAR === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showInactivateSuccessStatusHAR === 'false'">Unsuccessful</h4>
                </div>
              </div>
              <div class="row" *ngIf="showInactivateSuccessStatusKCW !== ''">
                <div class="col">
                  <h4>KCW Inactivate User Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showInactivateSuccessStatusKCW === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showInactivateSuccessStatusKCW === 'false'">Unsuccessful</h4>
                </div>
              </div>
              <div class="row" *ngIf="showInactivateSuccessStatusCPL !== ''">
                <div class="col">
                  <h4>CPL Inactivate User Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showInactivateSuccessStatusCPL === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showInactivateSuccessStatusCPL === 'false'">Unsuccessful</h4>
                </div>
              </div>
              <div class="row" *ngIf="showInactivateSuccessStatusEDGE !== ''">
                <div class="col">
                  <h4>EDG Inactivate User Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showInactivateSuccessStatusEDGE === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showInactivateSuccessStatusEDGE === 'false'">Unsuccessful</h4>
                </div>
              </div>
              <div class="row" *ngIf="showInactivateSuccessStatusNTLEDH !== ''">
                <div class="col">
                  <h4>NTLEDH Inactivate User Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showInactivateSuccessStatusNTLEDH === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showInactivateSuccessStatusNTLEDH === 'false'">Unsuccessful</h4>
                </div>
              </div>
              <div class="row" *ngIf="showInactivateSuccessStatusNTLCLF !== ''">
                <div class="col">
                  <h4>NTLCLF Inactivate User Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showInactivateSuccessStatusNTLCLF === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showInactivateSuccessStatusNTLCLF === 'false'">Unsuccessful</h4>
                </div>
              </div>

            </div>

            <!-- create user status -->
            <div *ngIf="showCreateUserStatuses">
              <div class="row" *ngIf="showSuccessStatusEDH !== ''">
                <div class="col">
                  <h4>EDH User Created Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showSuccessStatusEDH === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showSuccessStatusEDH === 'false'">Unsuccessful</h4>
                </div>
              </div>
              <div class="row" *ngIf="showSuccessStatusHAR !== ''">
                <div class="col">
                  <h4>HAR User Created Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showSuccessStatusHAR === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showSuccessStatusHAR === 'false'">Unsuccessful</h4>
                </div>
              </div>
              <div class="row" *ngIf="showSuccessStatusKCW !== ''">
                <div class="col">
                  <h4>KCW User Created Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showSuccessStatusKCW === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showSuccessStatusKCW === 'false'">Unsuccessful</h4>
                </div>
              </div>
              <div class="row" *ngIf="showSuccessStatusCPL !== ''">
                <div class="col">
                  <h4>CPL User Created Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showSuccessStatusCPL === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showSuccessStatusCPL === 'false'">Unsuccessful</h4>
                </div>
              </div>
              <div class="row" *ngIf="showSuccessStatusEDGE !== ''">
                <div class="col">
                  <h4>EDG User Created Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showSuccessStatusEDGE === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showSuccessStatusEDGE === 'false'">Unsuccessful</h4>
                </div>
              </div>
              <div class="row" *ngIf="showSuccessStatusNTLEDH !== ''">
                <div class="col">
                  <h4>NTLEDH User Created Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showSuccessStatusNTLEDH === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showSuccessStatusNTLEDH === 'false'">Unsuccessful</h4>
                </div>
              </div>
              <div class="row" *ngIf="showSuccessStatusNTLCLF !== ''">
                <div class="col">
                  <h4>NTLCLF User Created Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showSuccessStatusNTLCLF === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showSuccessStatusNTLCLF === 'false'">Unsuccessful</h4>
                </div>
              </div>

            </div>

            <!-- update template statuses -->
            <div *ngIf="showUpdateStatuses">
              <div class="row" *ngIf="showUpdateSuccessStatusEDH !== ''">
                <div class="col">
                  <h4>EDH Template Update Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showUpdateSuccessStatusEDH === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showUpdateSuccessStatusEDH === 'false'">Unsuccessful</h4>
                </div>
              </div>
              <div class="row" *ngIf="showUpdateSuccessStatusHAR !== ''">
                <div class="col">
                  <h4>HAR Template Update Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showUpdateSuccessStatusHAR === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showUpdateSuccessStatusHAR === 'false'">Unsuccessful</h4>
                </div>
              </div>
              <div class="row" *ngIf="showUpdateSuccessStatusKCW !== ''">
                <div class="col">
                  <h4>KCW Template Update Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showUpdateSuccessStatusKCW === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showUpdateSuccessStatusKCW === 'false'">Unsuccessful</h4>
                </div>
              </div>
              <div class="row" *ngIf="showUpdateSuccessStatusCPL !== ''">
                <div class="col">
                  <h4>CPL Template Update Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showUpdateSuccessStatusCPL === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showUpdateSuccessStatusCPL === 'false'">Unsuccessful</h4>
                </div>
              </div>
              <div class="row" *ngIf="showUpdateSuccessStatusEDGE !== ''">
                <div class="col">
                  <h4>EDG Template Update Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showUpdateSuccessStatusEDGE === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showUpdateSuccessStatusEDGE === 'false'">Unsuccessful</h4>
                </div>
              </div>
              <div class="row" *ngIf="showUpdateSuccessStatusNTLEDH !== ''">
                <div class="col">
                  <h4>NTLEDH Template Update Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showUpdateSuccessStatusNTLEDH === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showUpdateSuccessStatusNTLEDH === 'false'">Unsuccessful</h4>
                </div>
              </div>
              <div class="row" *ngIf="showUpdateSuccessStatusNTLCLF !== ''">
                <div class="col">
                  <h4>NTLCLF Template Update Status: </h4>
                </div>
                <div class="col">
                  <h4 style="color: green;" *ngIf="showUpdateSuccessStatusNTLCLF === 'true'">Successful</h4>
                  <h4 style="color: red;" *ngIf="showUpdateSuccessStatusNTLCLF === 'false'">Unsuccessful</h4>
                </div>
              </div>
            </div>



          </mat-card-content>
        </mat-card>
        <!-- </row> -->

      </div>

      <div class="col-md-6" *ngIf="showUserResults">
        <mat-card>

          <mat-card-header style="background-color: #004f86; padding: 5px; color: white;">
            <mat-card-title>{{userFormTitle}}</mat-card-title>
          </mat-card-header>
          <br>

          <mat-card-content>

            <div id="preloader-wrapper" *ngIf="loadScreen">
              <div id="preloader" class="preloader2"> </div>
            </div>

            <div [class.mat-elevation-z12]="true" style="padding: 12px" *ngIf="!loadScreen">
              <!-- editable fields with submit and cancel buttons -->
              <form>
                <div class="row">
                  <div class="col">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>First Name</mat-label>
                      <input [formControl]="firstNameControl" matInput placeholder="First Name" value="" maxlength="30">
                    </mat-form-field>
                  </div>

                  <div class="col">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Last Name</mat-label>
                      <input [formControl]="lastNameControl" matInput placeholder="Last Name" value="" maxlength="30">
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <mat-form-field appearance="outline" class="w-100" style="width: 300px;">
                      <mat-label>Email Address</mat-label>
                      <input matInput placeholder="Enter your email" [formControl]="email" required maxlength="100">
                      <mat-error *ngIf="email.invalid">{{getErrorMessage()}}</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <mat-form-field appearance="outline" class="w-100" style="width: 300px;">
                      <mat-label>ICC User Name</mat-label>
                      <input [formControl]="iccUserNameControl" matInput placeholder="ICC User Name" value=""
                        maxlength="8">
                    </mat-form-field>
                  </div>

                </div>

                <div class="row" *ngIf="creatingNewUser">
                  <div class="col">
                    <mat-form-field appearance="outline" class="w-100" style="width: 300px;">
                      <mat-label>Employee ID</mat-label>
                      <input [formControl]="employeeIdInputControl" matInput placeholder="Employee ID" value=""
                        maxlength="8">
                    </mat-form-field>
                  </div>
                </div>

                <!-- facility multiselect dropdown -->

                <div class="row">
                  <div class="col">
                    <mat-form-field appearance="outline" class="w-100" style="width: 300px;">
                      <mat-label>Facility</mat-label>
                      <mat-select placeholder="Select Options" [formControl]="multiselect" multiple>
                        <mat-option *ngFor="let option of selectOptionList" [value]="option"
                          (click)="setSecurityTemplateDropdown()">{{option}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <!-- access level template dropdown single -->

                <div class="row">
                  <div class="col">
                    <mat-form-field appearance="outline" class="w-100" style="width: 300px;">
                      <mat-label>Access Level Template</mat-label>
                      <mat-select [formControl]="accessLevelTemplateControl" placeholder="Access Level Template">
                        <mat-option *ngFor="let option of finalFinalSecurityTemplatesFiltered" [value]="option">
                          {{option}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <!-- buttons -->
                <div class="row">
                  <div class="button-row col">
                    <button class="mr-1" mat-flat-button color="primary" (click)="submitButton()"
                      [disabled]="disableSubmitButton">Submit</button>
                    <button class="mr-1" mat-flat-button color="primary" (click)="inactivateButton()"
                      [disabled]="creatingNewUser || disableInactivateButton">Inactivate</button>
                    <button mat-flat-button color="primary" (click)="cancelButton()">Cancel</button>
                  </div>
                </div>
              </form>
            </div>


          </mat-card-content>
        </mat-card>
      </div>

    </div>
  </div>
</div>